import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions';
import mutations from './mutations';
import { isDevelopment } from '@/utils/env';

// For demo purpose only
Vue.use(Vuex);

// const debug = process.env.NODE_ENV !== 'production';
// const strict = process.env.NODE_ENV !== 'production';

import proposal from './proposal';
import user from './user';
import campaign from './campaign';
import view from './view';
import newDashboard from './newDashboard';
import form from './form';
import file from './file';
import asset from './asset';
import strategy from './strategy';
import permission from './permission';
import dashboardEdit from './dashboardEdit';
import rawData from './rawData';
import dashboardHeader from './dashboardHeader';
import partner from './partner';
import printPDF from './printPDF';
import notepadWidget from './notepadWidget';
import mediaMixOptimizer from './mediaMixOptimizer';
import iframe from './iframe';
import blendSetting from './blendSetting';

const state = {
    count: 0,
    isLogoutModalActive: false,
};

const store = new Vuex.Store({
    strict: false,
    state,
    actions,
    mutations,
    modules: {
        proposal,
        user,
        campaign,
        view,
        newDashboard,
        form,
        file,
        asset,
        strategy,
        permission,
        dashboardEdit,
        rawData,
        dashboardHeader,
        partner,
        printPDF,
        notepadWidget,
        mediaMixOptimizer,
        iframe,
        blendSetting,
    },
    plugins: [],
});

export default store;

if (isDevelopment && module.hot) {
    // Accept the actions and mutations as hot modules
    module.hot.accept?.(['./actions', './mutations'], () => {
        const newActions = require('./actions').default;
        const newMutations = require('./mutations').default;
        store.hotUpdate({
            actions: newActions,
            mutations: newMutations,
        });
    });

    // Accept the modules as hot modules
    module.hot.accept?.(
        [
            './proposal',
            './user',
            './campaign',
            './view',
            './newDashboard',
            './form',
            './file',
            './asset',
            './strategy',
            './permission',
            './dashboardEdit',
            './rawData',
            './dashboardHeader',
            './partner',
            './printPDF',
            './notepadWidget',
            './mediaMixOptimizer',
            './iframe',
            './blendSetting',
        ],
        () => {
            const newProposal = require('./proposal').default;
            const newUser = require('./user').default;
            const newCampaign = require('./campaign').default;
            const newView = require('./view').default;
            const newNewDashboard = require('./newDashboard').default;
            const newForm = require('./form').default;
            const newFile = require('./file').default;
            const newAsset = require('./asset').default;
            const newStrategy = require('./strategy').default;
            const newPermission = require('./permission').default;
            const newDashboardEdit = require('./dashboardEdit').default;
            const newRawData = require('./rawData').default;
            const newDashboardHeader = require('./dashboardHeader').default;
            const newPartner = require('./partner').default;
            const newPrintPDF = require('./printPDF').default;
            const newNotepadWidget = require('./notepadWidget').default;
            const newMediaMixOptimizer = require('./mediaMixOptimizer').default;
            const newIframe = require('./iframe').default;
            const newBlendSetting = require('./blendSetting').default;

            // Swap in the new modules
            store.hotUpdate({
                modules: {
                    proposal: newProposal,
                    user: newUser,
                    campaign: newCampaign,
                    view: newView,
                    newDashboard: newNewDashboard,
                    form: newForm,
                    file: newFile,
                    asset: newAsset,
                    strategy: newStrategy,
                    permission: newPermission,
                    dashboardEdit: newDashboardEdit,
                    rawData: newRawData,
                    dashboardHeader: newDashboardHeader,
                    partner: newPartner,
                    printPDF: newPrintPDF,
                    notepadWidget: newNotepadWidget,
                    mediaMixOptimizer: newMediaMixOptimizer,
                    iframe: newIframe,
                    blendSetting: newBlendSetting,
                },
            });
        }
    );
}
